// src/components/UserForm.tsx
import { useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;

interface Props {
  onSuccess: (newUser: any) => void;
  onClose: () => void;
}

function UserForm({ onSuccess, onClose }: Props) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('viewer');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post(`${API_URL}/auth/create-user`, {
        username,
        email,
        password,
        role
      });
      onSuccess(res.data);
      onClose();
    } catch (err) {
      setError('Error al crear usuario');
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form.Group className="mb-3">
        <Form.Label>Usuario</Form.Label>
        <Form.Control value={username} onChange={e => setUsername(e.target.value)} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Contraseña</Form.Label>
        <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Rol</Form.Label>
        <Form.Select value={role} onChange={e => setRole(e.target.value)}>
          <option value="admin">Admin</option>
          <option value="editor">Editor</option>
          <option value="viewer">Viewer</option>
          <option value="clusters">Clusters</option>
          <option value="search">Clusters</option>
        </Form.Select>
      </Form.Group>
      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button type="submit" variant="primary">Crear</Button>
      </div>
    </Form>
  );
}

export default UserForm;